import store from '@/store';
import { defaultConfig } from './defaultConfig';

export const init = () => {
  if (!window.Beacon) {
    // eslint-disable-next-line no-console
    console.info('HelpScout Beacon is not available');

    return;
  }

  window.Beacon('config', defaultConfig);

  window.Beacon('on', 'open', () => {
    if (!store.getters['tracking/analyticsConsent']) {
      store.dispatch('modal/show', {
        type: 'HelpscoutStatisticsCard',
        stackable: true,
      });
    }
  });
};
